export default class Player {
  
  private _id: string;
  private _isActve: boolean;
  private _name: string;
  
  constructor(id: string, name: string, isActive: boolean) {
    this._id = id;
    this._isActve = isActive;
    this._name = name;
  }

  public get id(): string {
    return this._id;
  }
  public get isActve(): boolean {
    return this._isActve;
  }
  public get name(): string {
    return this._name;
  }
  
}